const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Zoom settings component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {CompanyIntegrations} CompanyIntegrations injected to gain access to the Company Integrations
 */
app.directive('stripeSettings', [
  'Application',
  'appConfiguration',
  'CompanyIntegrations',
  '$http',
  function (Application, appConfiguration, CompanyIntegrations, $http) {
    return {
      restrict: 'E',
      replace: true,
      scope: {},
      template: require('../../templates/directives/stripe-settings.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;

          self.add = function () {
            $http
              .post(appConfiguration.apiUrl + '/graphql', {
                query: 'mutation StripeInitiateAccount { stripeInitiateAccount { url } }',
              })
              .then(function (resp) {
                if (resp.data.data.stripeInitiateAccount) {
                  window.location.href = resp.data.data.stripeInitiateAccount.url;
                  return;
                }
                alert("Stripe account initiation failed. Please contact support.");
              });
          };

          self.initialize = function () {
            CompanyIntegrations.status(
              {},
              function (data) {
                self.companyIntegration = data || {};
                self.has = self.companyIntegration.stripe || false;
              },
              function (error) {
                console.log('Error occured getting company integration ', error);
              }
            );
          };
          self.initialize();
        },
      ],
      controllerAs: 'stripe',
    };
  },
]);
